
import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { CheckboxesCriterionContent } from '@/jbi-shared/types/criterions.types';
import { isTruthy } from '@/jbi-shared/util/watcher.vue-decorator';
import { isEqual as _isEqual } from 'lodash';
import draggable from 'vuedraggable';

@Component({
  components: { ValidationProvider, ValidationObserver, draggable },
  data() {
    const opts = (this as Vue & { options?: string[] }).options ?? [];
    return {
      dirtyOptions: [...opts],
      drag: false
    };
  }
})
export default class CheckboxesCriterionInput extends Vue {
  @Prop()
  public options!: CheckboxesCriterionContent['checkboxesOptions'];

  declare dirtyOptions: string[];
  declare drag: boolean;

  @Watch('dirtyOptions')
  public onChanged() {
    this.$emit('update:options', [...this.dirtyOptions]);
  }

  @isTruthy
  @Watch('options')
  public onRangeUpdated() {
    const opts = this.options ?? [];
    if (!_isEqual(this.dirtyOptions, opts)) {
      this.dirtyOptions = [...opts];
    }
  }
}
